import { formTypes } from '.';
import { documentTypesValueLabelList } from '../../catalogs/documentTypes';
import { paymentsTypesValueLabelList } from '../../catalogs/paymentTypes';
import { generalConceptsValueLabelList } from '../../catalogs/puc';

export const electronicInvoiceFields = {
  prefixId: { key: 'prefixId', label: 'Prefijo de la cuenta de cobro' },
id: { key: 'id', label: 'Número de la cuenta de cobro', placeholder: '30000000' },
  date: { key: 'date', label: 'Fecha de compra', type: formTypes.date },
  subtotal: { key: 'subtotal', label: 'Subtotal', type: formTypes.money, placeholder: '$300,000.00' },
  discount: { key: 'discount', label: 'Descuento', type: formTypes.money, placeholder: '$300,000.00' },
  iva: { key: 'iva', label: 'Iva', type: formTypes.money, placeholder: '$300,000.00' },
  consumptionTax: { key: 'consumptionTax', label: 'Impuesto al consumo', type: formTypes.money, placeholder: '$300,000.00' },
  totalValue: { key: 'totalValue', label: 'Monto total', type: formTypes.money, placeholder: '$300,000.00' },
  payMethod: { key: 'payMethod', label: 'Metodo de pago', type: formTypes.select, options: paymentsTypesValueLabelList },
  dueDate: { key: 'dueDate', label: 'Fecha de expiración', show: value => value.payMethod === 'CREDIT', type: formTypes.date },
  generalConcept: { key: 'generalConcept', label: 'Concepto general', type: formTypes.select, options: generalConceptsValueLabelList },
  specificConcept: { key: 'specificConcept', label: 'Concepto específico', type: formTypes.select }
};

export const thirdFields = {
  thirdId: { key: 'thirdId', label: 'Proveedor', type: formTypes.select, options: [] },
  thirdIdentificationType: {
    key: 'thirdIdentificationType',
    label: 'Tipo de identificación',
    show: value => value.thirdId === 'newThird',
    type: formTypes.select,
    options: documentTypesValueLabelList
  },
  thirdIdentificationNumber: {
    key: 'thirdIdentificationNumber',
    label: 'Identificación',
    show: value => value.thirdId === 'newThird',
    placeholder: '30000000',
    textHelper: 'Verifica el tipo de documento antes de continuar'
  },
  thirdEmail: {
    key: 'thirdEmail',
    label: 'e-mail',
    show: value => value.thirdId === 'newThird',
    validate: true,
    placeholder: 'hola@ejemplo.com'
  },
  thirdName: { key: 'thirdName', label: 'Nombre comercial', show: value => value.thirdId === 'newThird' },
  thirdBusinessName: {
    key: 'thirdBusinessName',
    label: 'Razón social',
    show: value => value.thirdId === 'newThird',
    placeholder: 'Republic Motors Incorporation'
  },
  thirdPhone: { key: 'thirdPhone', label: 'Teléfono', show: value => value.thirdId === 'newThird', type: formTypes.number },
  thirdAddress: {
    key: 'thirdAddress',
    label: 'Dirección',
    show: value => value.thirdId === 'newThird',
    placeholder: 'Calle 97 #72-107'
  }
};
